import { Icon } from '@mui/material';
import DynamicIcon from '../dynamicicon';

function JisEmptyList({ title="There is no item to display"  }) {
 


  return <div >
 <span className='label'>{title}</span> 
   </div>;
}

export default JisEmptyList;